import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Component } from "react";
import Landing from "@/components/Landing";
import AreaPersonale from "@/pages/AreaPersonale";
import AuthCallback from "@/components/AuthCallback";
import { WhatsAppIcon, WHATSAPP_URL } from "@/components/WhatsAppIcon";

const WhatsAppBubble = () => (
    <a
        href={WHATSAPP_URL}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float"
        aria-label="Scrivici su WhatsApp"
        className="fixed bottom-5 right-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-xl shadow-ink/20 transition-transform duration-300 hover:scale-110 hover:shadow-2xl"
    >
        <WhatsAppIcon className="h-7 w-7" />
    </a>
);

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    render() {
        if (this.state.hasError) {
            return (
                <div className="min-h-screen bg-cream flex items-center justify-center p-6">
                    <p className="font-serif text-2xl text-ink">
                        Qualcosa è andato storto. Ricarica la pagina.
                    </p>
                </div>
            );
        }
        return this.props.children;
    }
}

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};

const AppRouter = () => {
    const location = useLocation();
    // OAuth callback: detect session_id synchronously during render (before /auth/me checks)
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/area-personale" element={<AreaPersonale />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (t) => {
            lenis.raf(t);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <ErrorBoundary>
            <div className="noise-overlay" aria-hidden="true" />
            <BrowserRouter>
                <ScrollToTop />
                <AppRouter />
                <WhatsAppBubble />
            </BrowserRouter>
        </ErrorBoundary>
    );
}

export default App;
